import { BOARD_TYPES } from "../../../../utils/exports/board-types"

export const TEE_SHEET_CONFIG_VERSION = 1

export const TEE_SHEET_SECTIONS = [
	{
		id: "enquiry_confirmation",
		title: "Enquiry confirmation",
		description: "Start by checking the original enquiry details are accurate.",
		questions: [
			{
				id: "confirm_original_enquiry_details",
				question:
					"Confirmed that this client has made the enquiry with the specified dates, nights, rounds, and location or area all matching as per the original enquiry.",
				type: "boolean",
				required: true,
			},
		],
	},
	{
		id: "about_the_trip",
		title: "About the trip",
		description: "",
		questions: [
			{
				id: "specific_or_open_location",
				question:
					"Are you only looking for quotes to [X Hotel], or are you open to other hotel options in the area?",
				type: "select",
				options: {
					only_this_hotel: "Only looking for this hotel",
					others_in_area: "Look at others in the area",
					other_regions: "Look at other regions that are not close by",
					unsure: "Unsure",
				},
			},
			{
				id: "preferred_area_style",
				question: "What type of accommodation are you looking for?",
				type: "multi_select",
				options: {
					resort_style_complex: "Resort-style complex",
					outskirts_of_town: "Outskirts of a town",
					nightlife_area: "In and around nightlife",
					flexible: "Flexible",
				},
				disabledWhen: {
					questionId: "specific_or_open_location",
					value: "only_this_hotel",
				},
			},
			{
				id: "date_flexibility",
				question:
					"Is your check-in date fixed or are you open to looking at nearby dates if it helps find the best options?",
				type: "select",
				options: {
					not_flexible: "Dates are not flexible",
					one_week: "+/- 1 week",
					two_weeks: "+/- 2 weeks",
					three_weeks: "+/- 3 weeks",
					four_weeks: "+/- 4 weeks",
					very_flexible: "Dates are very flexible",
					unsure: "Unsure",
				},
			},
			{
				id: "golf_holiday_experience",
				question: "Have you been on a golf holiday before? Or is this your first time going away?",
				type: "select",
				options: {
					been_on_golf_holiday_before: "Been on a golf holiday before",
					new_to_golf_holidays: "I'm new to a golf holiday",
				},
			},
			{
				id: "year_on_year_trip",
				question: "Is this a trip that you (and the group) look to do year-on-year?",
				type: "select",
				options: {
					yes_every_year: "Yes, every year",
					yes_not_every_year: "Yes, but not every year",
					no: "No",
					unsure: "Unsure",
				},
				dependsOn: {
					questionId: "golf_holiday_experience",
					value: "been_on_golf_holiday_before",
				},
			},
			{
				id: "previous_trip_locations",
				question: "Where have you typically gone away?",
				type: "textarea",
				dependsOn: {
					questionId: "golf_holiday_experience",
					value: "been_on_golf_holiday_before",
				},
			},
			{
				id: "previous_booking_and_reason_for_change",
				question: "Where have you previously booked your trips, and what is it that made you look elsewhere?",
				type: "textarea",
				dependsOn: {
					questionId: "golf_holiday_experience",
					value: "been_on_golf_holiday_before",
				},
			},
			{
				id: "trip_style",
				question: "What would you say is most important for your trip in terms of quality?",
				type: "select",
				options: {
					high_quality_hotels: "Preference on high-quality hotels",
					high_quality_courses: "Preference on high-quality golf courses",
					high_quality_both: "Looking for high quality in both",
					mid_range_best_value: "Mid-range best value",
				},
			},
			{
				id: "trip_budget",
				question: "What is your budget for the trip?",
				type: "text",
				prefix: "£",
			},
			{
				id: "trip_budget_max",
				question: "Do you have a maximum that you'd like to spend?",
				type: "text",
				prefix: "£",
			},
			{
				id: "best_trip_inclusions",
				question:
					"What are you looking to have included on this trip to make it perfect? (Based on previous trips)",
				type: "textarea",
			},
			{
				id: "group_must_haves",
				question:
					"Is there anything that you'd like included on your holiday quote as a non-negotiable, 100% must have?",
				type: "textarea",
			},
			{
				id: "special_occasion",
				question: "Is there a special occasion for this trip?",
				type: "select",
				options: {
					birthday: "Birthday",
					society: "Society",
					charity: "Charity",
					family: "Family",
					friends: "Friends",
					retirement: "Retirement",
					no_special_occasion: "No special occasion",
				},
			},
		],
	},
	{
		id: "accommodation",
		title: "Accommodation",
		description: "",
		questions: [
			{
				id: "room_types",
				question: "What room types are you looking for?",
				type: "multi_select",
				options: {
					single_rooms: "Single rooms",
					twin_rooms: "Twin rooms",
					double_rooms: "Double rooms",
					other: "Other",
				},
			},
			{
				id: "board_basis",
				question: "What board basis are you looking for?",
				type: "multi_select",
				options: BOARD_TYPES,
			},
		],
	},
	{
		id: "golf",
		title: "Golf",
		description: "",
		questions: [
			{
				id: "tee_time_preferences",
				question: "What tee times would you prefer?",
				type: "multi_select",
				options: {
					early_morning: "Early morning",
					mid_morning: "Mid-morning",
					late_morning: "Late morning",
					midday: "Midday",
					early_afternoon: "Early afternoon",
					mid_afternoon: "Mid-afternoon",
				},
			},
			{
				id: "course_difficulty",
				question: "What difficulty of course would you be looking to play while you're away?",
				type: "select",
				options: {
					okay_with_hard: "I'm okay with hard",
					okay_with_medium: "I'm okay with medium",
					need_easy: "I need easy",
					unsure: "Unsure",
				},
			},
			{
				id: "golf_course_shuttles",
				question: "Do you need golf shuttles between courses while you're there?",
				type: "boolean",
			},
			{
				id: "buggies_all_rounds",
				question: "Do you require buggies for your rounds?",
				type: "boolean",
			},
		],
	},
	{
		id: "flights",
		title: "Flights",
		description: "",
		questions: [
			{
				id: "needs_flights",
				question: "Would you like me to include flights?",
				type: "boolean",
			},
			{
				id: "flying_from",
				question: "Where do you like to fly from?",
				type: "text",
				dependsOn: {
					questionId: "needs_flights",
					value: true,
				},
			},
			{
				id: "own_golf_clubs",
				question: "Will you be taking your own golf clubs?",
				type: "boolean",
				dependsOn: {
					questionId: "needs_flights",
					value: true,
				},
			},
			{
				id: "baggage_type",
				question: "What kind of baggage would you like?",
				type: "select",
				options: {
					cabin_only: "Cabin bag only",
					cabin_and_suitcase: "Cabin bag and suitcase",
					cabin_and_large_suitcase: "Cabin bag and large suitcase",
				},
				dependsOn: {
					questionId: "needs_flights",
					value: true,
				},
			},
			{
				id: "flight_time_preference",
				question: "When would you prefer to fly?",
				type: "select",
				options: {
					morning: "Morning",
					midday: "Midday",
					afternoon: "Afternoon",
				},
				dependsOn: {
					questionId: "needs_flights",
					value: true,
				},
			},
			{
				id: "airline_preference",
				question: "Do you have a preference on airline?",
				type: "select",
				options: {
					easyjet: "EasyJet",
					ryanair: "Ryanair",
					jet2: "Jet2",
					british_airways: "British Airways",
					american_airlines: "American Airlines",
					other: "Other",
				},
				dependsOn: {
					questionId: "needs_flights",
					value: true,
				},
			},
		],
	},
	{
		id: "transfers_and_car_hire",
		title: "Transfers and Car Hire",
		description: "",
		questions: [
			{
				id: "airport_transfers",
				question: "Would you like airport transfers?",
				type: "boolean",
			},
			{
				id: "car_hire",
				question: "Are you looking to hire a car?",
				type: "boolean",
			},
			{
				id: "car_hire_type",
				question: "What type of car would you like?",
				type: "select",
				options: {
					small: "Small",
					medium: "Medium",
					large: "Large",
					suv: "SUV",
				},
				dependsOn: {
					questionId: "car_hire",
					value: true,
				},
			},
		],
	},
	{
		id: "close_out",
		title: "Close out",
		description: "",
		questions: [
			{
				id: "booking_timeline",
				question: "When are you looking to get this booked in (less than a week, one week, two weeks, or future trip)?",
				type: "select",
				options: {
					less_than_week: "Less than a week",
					one_week: "One week",
					two_weeks: "Two weeks",
					future_trip: "Future trip",
				},
			},
			{
				id: "missed_imperative_details",
				question: "Is there anything on this call that I may have missed that you believe is imperative for the group?",
				type: "textarea",
			},
		],
	},
	{
		id: "statements",
		title: "Statements",
		description: "",
		questions: [
			{
				id: "confirm_client_contact",
				question: "Can I just reconfirm with you the best details I have on file?",
				type: "confirm_contact",
				contactFields: [
					{ id: "email", label: "Email", clientField: "email" },
					{ id: "phone", label: "Phone", clientField: "phone" },
				],
			},
			{
				id: "callback_time_preference",
				question: "When is the best time during the day for me to give you a call regarding any quotes I send over?",
				type: "select",
				options: {
					morning: "Morning",
					late_morning: "Late morning",
					midday: "Midday",
					early_afternoon: "Early afternoon",
					late_afternoon: "Late afternoon",
					any_time: "Any time",
				},
			},
			{
				id: "deposit_statement",
				question: "We only require a £50 per person deposit to secure your booking.",
				type: "boolean",
				labels: { on: "Done", off: "No" },
			},
			{
				id: "payment_flexibility_statement",
				question:
					"You can then make payments towards your holiday as little or as often as you like up to 12 weeks before travel, with no additional interest added on, through our Manage My Booking portal.",
				type: "boolean",
				labels: { on: "Done", off: "No" },
			},
			{
				id: "any_other_questions",
				question: "Are there any other questions you have surrounding the trip that I can answer for you before I put a quote together?",
				type: "boolean",
				labels: { on: "Done", off: "No" },
			},
		],
	},
]

export const TEE_SHEET_CONFIG = {
	version: TEE_SHEET_CONFIG_VERSION,
	sections: TEE_SHEET_SECTIONS,
}
